import type {
  CourseDefinitionQuizQuestionResponse,
  CourseSessionQuizQuestionAnswerRequest,
  CourseSessionQuizQuestionRequest,
  CourseSessionQuizRequest,
  CourseSessionQuizResponse} from 'src/api/ProactApiClient';
import {
  CourseDefinitionQuizQuestionTypeEnum
} from 'src/api/ProactApiClient';
import type {PillProps} from 'src/design/atoms/Pill';

export function GetSessionSubtitle(
  contentIndex?: number,
  contentLength?: number,
  contentText?: string
): string {
  return `Content ${(contentIndex ?? 0) + 1} of ${contentLength}: ${
    contentText ?? 'Unknown title'
  }`;
}

export function GetQuizScoreLine(
  scorePassPercentage: number,
  questions?: CourseDefinitionQuizQuestionResponse[]
): string {
  const safeQuestions = questions ?? [];
  let totalPoints = 0;
  safeQuestions.map(q => q.scoreValue).forEach(score => (totalPoints += score));
  return `This quiz contains ${safeQuestions.length} questions worth ${totalPoints} points. You must score a ${scorePassPercentage}% or higher to pass this quiz. If you do not meet the required score, you will be required to take the training again.`;
}

export function GetQuestionLabel(
  index: number,
  question: CourseDefinitionQuizQuestionResponse
): string {
  const questionNumber = index + 1;
  return `${questionNumber}. ${question.labelText}`;
}

export function GetQuestionTypeLabel(
  question: CourseDefinitionQuizQuestionResponse
): PillProps {
  const props: PillProps =
    question.type === CourseDefinitionQuizQuestionTypeEnum.SingleChoice
      ? {
          text: 'Single choice',
          color: 'gray',
        }
      : {
          text: 'Multiple choice',
          color: 'gray',
        };
  return props;
}

export function GetQuestionInstructionLabel(
  question: CourseDefinitionQuizQuestionResponse
): string {
  const type =
    question.type === CourseDefinitionQuizQuestionTypeEnum.SingleChoice
      ? 'Single choice'
      : 'Multiple choice';

  const instruction = `${type} - ${question.scoreValue} points`;
  return instruction;
}

export function MapQuizResponseToQuizRequest(
  quiz?: CourseSessionQuizResponse
): CourseSessionQuizRequest | undefined {
  if (!quiz) {
    return undefined;
  }

  return {
    quizDefinitionId: quiz.quizDefinitionId,
    questions: quiz.questions?.map(
      q =>
        ({
          questionDefinitionId: q.questionDefinitionId,
          answers: q.answers?.map(
            a =>
              ({
                isSelected: a.isSelected,
                answerDefinitionId: a.answerDefinitionId,
              } as CourseSessionQuizQuestionAnswerRequest)
          ),
        } as CourseSessionQuizQuestionRequest)
    ),
  } as CourseSessionQuizRequest;
}
